import { render, staticRenderFns } from "./KnoCard.vue?vue&type=template&id=1cbab0ac&scoped=true"
import script from "./KnoCard.vue?vue&type=script&lang=js"
export * from "./KnoCard.vue?vue&type=script&lang=js"
import style0 from "./KnoCard.vue?vue&type=style&index=0&id=1cbab0ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbab0ac",
  null
  
)

export default component.exports